export default __webpack_public_path__ + "static/media/DNo.38-3.36238030.jpg";